﻿import { loadFullPage } from './utilidades/loadFullPage';
import { removeCacheUsuarioLogado } from './utilidades/usuarioLogado';

const loginSair = function () { 
    const init = function () {
        loadFullPage.mostrar();
        removeCacheUsuarioLogado();
        return window.location.href = `/${CULTURE_EMPREGARE}`;
    };

    return init();
};

loginSair();